module.exports = __webpack_public_path__ + "static/media/XXXe.9782aa68.png";